import moment from 'moment';
import { useTranslation } from 'react-i18next';
import columnGenerator from '../components/DataGridCustom/ColumnGenerator';

interface SortModel {
  field: string;
  sort: 'asc' | 'desc';
}

interface FilterModel {
  field: string;
  operator: string;
  value: any;
}

const useMeasurerTable = (
  state: any,
  isParcStatus: boolean = false,
  renderCellMethod?: any,
) => {
  const { t } = useTranslation();

  let columns: any = [
    {
      ...columnGenerator('measurer', 'device'),
      headerName: t('measurer.device'),
      valueGetter: (value: any) => {
        return value.row.device.deviceName;
      },
    },
    {
      ...columnGenerator('measurer', 'measurerCategory'),
      headerName: t('measurer.measurerCategory'),
      valueGetter: (value: any) => {
        return t(
          `measurerCategory.${value.row.measurerCategory.toLowerCase()}`,
        );
      },
    },
    {
      ...columnGenerator('measurer', 'measurementType'),
      headerName: t('measurer.measurementType'),
      valueGetter: (value: any) => {
        return t(`measurementType.${value.row.measurementType.toLowerCase()}`);
      },
    },

    {
      ...columnGenerator('measurer', 'alarmState'),
      headerName: t('measurer.alarmState'),
      ...(isParcStatus
        ? {
            renderCell: (params: any) => renderCellMethod(params),
          }
        : {
            valueGetter: (value: any) => {
              return t(`alarmState.${value.row.alarmState.toLowerCase()}`);
            },
          }),
    },

    {
      ...columnGenerator('measurer', 'lastAlarmDate'),
      headerName: t('measurer.lastAlarmDate'),
      valueGetter: (value: any) => {
        return value.row.lastAlarmDate
          ? moment(value.row.lastAlarmDate).format('DD/MM/YYYY HH:mm')
          : null;
      },
    },

    {
      ...columnGenerator('measurer', 'lastMeasurement'),
      headerName: t('measurer.lastMeasurement') || 'Dernier relevé',
      valueGetter: (value: any) => {
        return value.row.lastMeasurement?.measurementDate
          ? moment(value.row.lastMeasurement.measurementDate).format('DD/MM/YYYY HH:mm')
          : null;
      },
    },

    {
      ...columnGenerator('measurer', 'duration'),
      headerName: t('measurer.duration') || 'Durée',
      valueGetter: (value: any) => {
        const details = value.row.lastMeasurementDurationDetails;
        if (!details) return null;
        const parts = [];
        if (details.days > 0) parts.push(`${details.days}j`);
        if (details.hours > 0) parts.push(`${details.hours}h`);
        if (details.minutes > 0) parts.push(`${details.minutes}m`);
        if (details.seconds > 0) parts.push(`${details.seconds}s`);
        return parts.length > 0 ? parts.join(' ') : null;
      },
    },
  ];

  const sortModel: SortModel[] = [{ field: 'deviceIdentifier', sort: 'asc' }];
  const filterModel: FilterModel[] = state?.deviceIdentifier
    ? [{ field: 'device', operator: 'contains', value: state.deviceIdentifier }]
    : [];

  // Other logic or side effects can be added here

  return {
    columns,
    sortModel,
    filterModel,
  };
};

export default useMeasurerTable;
